// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderlessTableOutlinedSvg from "@ant-design/icons-svg/es/asn/BorderlessTableOutlined";
import AntdIcon from '../components/AntdIcon';

var BorderlessTableOutlined = function BorderlessTableOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BorderlessTableOutlinedSvg
  }));
};

BorderlessTableOutlined.displayName = 'BorderlessTableOutlined';
export default React.forwardRef(BorderlessTableOutlined);